import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatSliderModule } from '@angular/material/slider';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-formly-slider',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyModule, MatSliderModule, ReactiveFormsModule, MatFormFieldModule],
  template: `
    @if (props.label) {
      <label class="font-medium block mb-2" [for]="id">{{ props.label }}{{ props.required ? ' *' : '' }}</label>
    }
    <mat-slider
      [min]="props.min ?? 0"
      [max]="props.max ?? 100"
      [step]="props.step ?? 1"
      [disabled]="props.disabled">
      <input matSliderThumb [id]="id" [formControl]="formControl" />
    </mat-slider>
    @if (field.props.description) {
      <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
    }
  `,
})
export class FormlySliderComponent extends FieldType {}
